module.exports = __webpack_public_path__ + "img/circle.bb65f836.svg";